var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { loading } from '../../../elements/Loading';
import { inject } from 'mobx-react';
import { Card, Col, Container, FormGroup, Label, Row, Input } from 'reactstrap';
import { t, T } from 'helpers/i18n';
import history from '../../../helpers/History';
import { Button, Loading } from '../../../elements';
import History from '../../../helpers/History';
import { ButtonsBar, StyledButton } from '../../../Styles';
import { toRound } from '../../../helpers/Format';
var CollaboratorPacketsFormEdit = /** @class */ (function (_super) {
    __extends(CollaboratorPacketsFormEdit, _super);
    function CollaboratorPacketsFormEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            packetTIN: '',
            editedServiceTINEnabled: false,
            isLoading: false
        };
        _this.handleOnChange = function (event) {
            var value = event.target.value;
            var editedServiceTINEnabled = value !== _this.props.collaboratorPacket.packetTIN;
            _this.setState({ packetTIN: value, editedServiceTINEnabled: editedServiceTINEnabled });
        };
        _this.handleOnClick = function () {
            _this.setState({ isLoading: true });
            _this.props.store.collaboratorPacketsStore.updatePacketTIN(_this.state.packetTIN, _this.props.collaboratorPacket.row_id, _this.props.collaboratorPacket.id, _this.props.collaboratorPacket.operator_id).then(function (value) {
                _this.setState({ editedServiceTINEnabled: false, isLoading: false });
            });
        };
        return _this;
    }
    CollaboratorPacketsFormEdit.prototype.componentDidMount = function () {
        if (this.props.collaboratorPacket.packetTIN && !this.state.packetTIN) {
            this.setState({ packetTIN: this.props.collaboratorPacket.packetTIN });
        }
    };
    CollaboratorPacketsFormEdit.prototype.render = function () {
        var collaboratorPacket = this.props.collaboratorPacket;
        var _a = this.state, packetTIN = _a.packetTIN, editedServiceTINEnabled = _a.editedServiceTINEnabled, isLoading = _a.isLoading;
        var hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        if (!collaboratorPacket) {
            return React.createElement(Loading, null);
        }
        var disabled = !editedServiceTINEnabled;
        console.log('collaboratorPacket: ', collaboratorPacket);
        var allStretches = __spreadArray(__spreadArray([], collaboratorPacket.stretches, true), collaboratorPacket.collaboratorStretches, true);
        return (React.createElement("div", { className: "pb-5" },
            React.createElement(Container, null,
                React.createElement(Card, { className: "m-3 p-3" },
                    React.createElement(Container, null,
                        React.createElement(Card, { className: "m-3 p-3" },
                            React.createElement(Row, { form: true },
                                React.createElement(Col, null,
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('owner')),
                                        React.createElement(Input, { value: collaboratorPacket.operatorName, disabled: true })))),
                            React.createElement(Row, { form: true },
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('name')),
                                        React.createElement(Input, { value: collaboratorPacket.name, disabled: true })))),
                            React.createElement(Row, { form: true },
                                React.createElement(Col, null,
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('tin') + ' visible en el ticket'),
                                        React.createElement(Input, { value: packetTIN, onChange: this.handleOnChange })),
                                    editedServiceTINEnabled && React.createElement(FormGroup, null,
                                        React.createElement(Button, { style: { marginBottom: '10px' }, onClick: this.handleOnClick, disabled: disabled, loading: isLoading }, T('save')))))),
                        React.createElement(Row, { form: true, className: "p-3" },
                            React.createElement(Col, { xl: 4, sm: 12 }, collaboratorPacket.prices &&
                                React.createElement("div", null,
                                    React.createElement(Card, { className: "p-3 mr-6 ml-6 ml-sm-3" },
                                        React.createElement(Label, null, T('prices')),
                                        React.createElement(Container, null,
                                            React.createElement(Row, null, collaboratorPacket.prices.map(function (price) { return (React.createElement(Col, { md: 4, lg: 6 },
                                                React.createElement(Label, null, price.passengerCategory.name),
                                                React.createElement(Input, { style: { marginBottom: '10px' }, disabled: true, value: toRound(price.price) }))); }))))))))),
                allStretches && (React.createElement(Container, null,
                    React.createElement(Card, { className: "m-3 p-3", style: { display: 'inline-block' } },
                        React.createElement("p", null, T('stretches')),
                        allStretches.map(function (stretch) { return (React.createElement("span", { className: "m-2" },
                            React.createElement(Label, null, stretch.name))); }))))),
            React.createElement(ButtonsBar, null, hasParent && (React.createElement(StyledButton, { onClick: function () { history.goBack(); } }, t('ok'))))));
    };
    CollaboratorPacketsFormEdit = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params ? props.store.collaboratorPacketsStore.read({
                operator_id: Number(props.match.params.operator_id),
                packet_id: Number(props.match.params.packet_id)
            })
                .then(function (collaboratorPacket) { return ({ collaboratorPacket: collaboratorPacket }); }) : undefined
        ]; })
    ], CollaboratorPacketsFormEdit);
    return CollaboratorPacketsFormEdit;
}(Component));
export default CollaboratorPacketsFormEdit;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorPackets/container/CollaboratorPacketsFormEdit.tsx
// module id = 1610
// module chunks = 0